import { scrollToSection } from './scroll';

// Add scrollToSection function globally
window.scrollToSection = scrollToSection;
